module.exports = __webpack_public_path__ + "img/ticketing_404.eef6c6d4.png";